module.exports = __webpack_public_path__ + "img/error-401.37991a61.svg";